import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: "#FFF7F1" },
          100: { value: "#FFEEEE" },
          200: { value: "#FFD4B8" },
          300: { value: "#FFAA7A" },
          400: { value: "#FF7F3C" },
          500: { value: "#FF5309" }, // MallBuddy Orange - Primary
          600: { value: "#E64A08" },
          700: { value: "#CC4207" },
          800: { value: "#B33A06" },
          900: { value: "#992F05" },
        },
        gray: {
          50: { value: "#FAFAFA" },
          100: { value: "#F5F5F5" },
          200: { value: "#ECECEC" },
          300: { value: "#D4D4D4" },
          400: { value: "#A3A3A3" },
          500: { value: "#929292" },
          600: { value: "#606060" },
          700: { value: "#414141" },
          800: { value: "#211D1D" },
          900: { value: "#121212" },
        },
        sidebar: {
          bg: { value: "#1A1A2E" },
          hover: { value: "#252542" },
          active: { value: "#FF5309" },
          text: { value: "#FFFFFF" },
          textMuted: { value: "#A0A0B0" },
        },
      },
      fonts: {
        heading: { value: "'Karla', sans-serif" },
        body: { value: "'Karla', sans-serif" },
      },
      fontSizes: {
        xs: { value: "0.75rem" },
        sm: { value: "0.875rem" },
        md: { value: "1rem" },
        lg: { value: "1.125rem" },
        xl: { value: "1.25rem" },
        "2xl": { value: "1.5rem" },
        "3xl": { value: "1.875rem" },
        "4xl": { value: "2.25rem" },
      },
      radii: {
        none: { value: "0" },
        sm: { value: "4px" },
        md: { value: "8px" },
        lg: { value: "12px" },
        xl: { value: "16px" },
        full: { value: "9999px" },
      },
    },
    semanticTokens: {
      colors: {
        primary: { value: "{colors.brand.500}" },
        accent: { value: "#FF5655" },
        background: { value: "{colors.brand.50}" },
        surface: { value: "{colors.brand.100}" },
        text: { value: "{colors.gray.900}" },
        textSecondary: { value: "{colors.gray.600}" },
        textTertiary: { value: "{colors.gray.800}" },
        disabled: { value: "{colors.gray.200}" },
        placeholder: { value: "{colors.gray.500}" },
        border: { value: "{colors.gray.200}" },
        success: { value: "#22C55E" },
        warning: { value: "#F59E0B" },
        error: { value: "#EF4444" },
        info: { value: "#3B82F6" },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);

export { system as theme };

// Typography styles for consistent text
export const Typography = {
  heading: {
    fontFamily: "'Karla', sans-serif",
    fontSize: "28px",
    lineHeight: "33.6px",
    fontWeight: "600",
    color: "#121212",
  },
  subheading: {
    fontFamily: "'Karla', sans-serif",
    fontSize: "14px",
    lineHeight: "23px",
    fontWeight: "500",
    color: "#606060",
  },
  body: {
    fontFamily: "'Karla', sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "400",
    color: "#414141",
  },
  caption: {
    fontFamily: "'Karla', sans-serif",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: "400",
    color: "#606060",
  },
};

// Color constants for easy access
export const colors = {
  primary: "#FF5309",
  accent: "#FF5655",
  background: "#FFF7F1",
  surface: "#FFEEEE",
  text: "#121212",
  textSecondary: "#606060",
  textTertiary: "#211D1D",
  disabled: "#ECECEC",
  placeholder: "#929292",
  white: "#FFFFFF",
  sidebar: {
    bg: "#ffff",
    hover: "#FFF7F1",
    active: "#FF5309",
    text: "#A0A0B0",
    textMuted: "#A0A0B0",
  },
};

export default system;
